// extracted by mini-css-extract-plugin
export default {"background":"CategoryView_background__oSo1X","container":"CategoryView_container__aLgbC","list":"CategoryView_list__34FB4"};